/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'tabSettings.label': {
    id: 'tabSettings.label',
    defaultMessage: 'Settings',
  },
  'tabCode.label': {
    id: 'tabCode.label',
    defaultMessage: 'Code',
  },
  'codeSection.expandButton.expand': {
    id: 'codeSection.expandButton.expand',
    defaultMessage: 'Expand',
  },
  'codeSection.expandButton.collapse': {
    id: 'codeSection.expandButton.collapse',
    defaultMessage: 'Collapse',
  },
});
